<script>
  import _ from 'underscore'
  import ItemPage from '../components/ItemPage.vue'
  import ItemList from '../components/ItemList.vue'
  import PageChooser from '../components/PageChooser.vue'
  import Status from '../components/Status.vue'
  import { item, externalItem } from '../components/Item.vue'
  import Vol02 from './Vol02.vue'
  import Vol04 from './Vol04.vue'
  import Jewel01 from './Jewel01.vue'
  import Jewel04 from './Jewel04.vue'
  import Jewel05 from './Jewel05.vue'
  import Promo2020 from './Promo2020.vue'

  /** @typedef {import('../components/Item.vue').ItemInfo} ItemInfo */


  /**
   * 過去弾の HR のアイテム情報群
   * @type {ItemInfo[]}
   */
  const externalHRs = _.where(
    [
      ...Jewel01.data().items,
      ...Jewel04.data().items,
      ...Jewel05.data().items,
    ],
    { rare: 'HR' }
  )

  /**
   * 過去弾のパシャッとアイテム情報群
   * @type {ItemInfo[]}
   */
  const externalPashaItems = _.where(
    [
      ...Vol02.data().items,
      ...Vol04.data().items,
    ],
    { kind: 'パシャッとアイテム' }
  )

  /**
   * 過去弾の HR のアイテム情報を流用する
   * @param {string} id アイテムID
   * @param {ItemInfo} payload アイテム情報に混ぜ込みたい内容
   * @return {ItemInfo} アイテム情報
   * @see {externalItem}
   */
  function externalHR (id = '', payload = {}) {
    return externalItem(externalHRs, id, payload)
  }

  /**
   * 過去弾のパシャッとアイテム情報を流用する
   * @param {string} id アイテムID
   * @param {ItemInfo} payload アイテム情報に混ぜ込みたい内容
   * @return {ItemInfo} アイテム情報
   * @see {externalItem}
   */
  function externalPashaItem (id = '', payload = {}) {
    return externalItem(externalPashaItems, id, payload)
  }

  /**
   * プロモ2020のアイテム情報を流用する
   * @param {string} id アイテムID
   * @param {ItemInfo} payload アイテム情報に混ぜ込みたい内容
   * @return {ItemInfo} アイテム情報
   * @see {externalItem}
   */
  function promo2020Item (id = '', payload = {}) {
    return externalItem(Promo2020.data().items, id, payload)
  }


  export default {
    components: { ItemPage, ItemList, PageChooser, Status },

    data () {
      return {
        date : '2021-08-28',
        major: [
          'PT04',
        ],
        excepts: [
        ],
        items: [

          // [NOTE] WR
          // ================================================================================

          item({
            collection  : 'PT04',
            id          : 'PT4-85',
            rare        : 'WR',
            name        : 'プレシャスミューズみらいワンピ',
            imgUrl      : '/images/items/PT4-85.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : 'SH|PM',
            type        : 'LO|PR',
            point       : 2000,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-86',
            rare        : 'WR',
            name        : 'プレシャスミューズみらいシューズ',
            imgUrl      : '/images/items/PT4-86.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'SH|PM',
            type        : 'LO|PR',
            point       : 1000,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-87',
            rare        : 'WR',
            name        : 'プレシャスミューズみらいヘアアクセ',
            imgUrl      : '/images/items/PT4-87.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'SH|PM',
            type        : 'LO|PR',
            point       : 1000,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            rare        : 'WR',
          }),


          item({
            collection  : 'PT04',
            id          : 'PT4-88',
            rare        : 'WR',
            name        : 'スイートハニーアンジュワンピ',
            imgUrl      : '/images/items/PT4-88.png',
            kind        : 'ワンピース',
            color       : '水',
            brand       : 'PM|SH',
            type        : 'PR|LO',
            point       : 2000,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-89',
            rare        : 'WR',
            name        : 'スイートハニーアンジュシューズ',
            imgUrl      : '/images/items/PT4-89.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'PM|SH',
            type        : 'PR|LO',
            point       : 1000,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-90',
            rare        : 'WR',
            name        : 'スイートハニーアンジュヘアアクセ',
            imgUrl      : '/images/items/PT4-90.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'PM|SH',
            type        : 'PR|LO',
            point       : 1000,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            rare        : 'WR',
          }),


          // [NOTE] ER
          // ================================================================================

          item({
            collection  : 'PT04',
            id          : 'ER4-01',
            rare        : 'ER',
            name        : 'クラシックはあと♡パールワンピ',
            imgUrl      : '/images/items/ER4-01.png',
            kind        : 'ワンピース',
            color       : '黒',
            brand       : 'CH',
            type        : 'LO',
            point       : 2000,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'ER4-02',
            rare        : 'ER',
            name        : 'クラシックはあと♡パールシューズ',
            imgUrl      : '/images/items/ER4-02.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'CH',
            type        : 'LO',
            point       : 950,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'ER4-03',
            rare        : 'ER',
            name        : 'クラシックはあと♡パールヘアアクセ',
            imgUrl      : '/images/items/ER4-03.png',
            kind        : 'ヘアアクセ',
            color       : '金',
            brand       : 'CH',
            type        : 'LO',
            point       : 950,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            rare        : 'ER',
          }),


          item({
            collection  : 'PT04',
            id          : 'ER4-04',
            rare        : 'ER',
            name        : 'クラシックプレシャスミューズワンピ',
            imgUrl      : '/images/items/ER4-04.png',
            kind        : 'ワンピース',
            color       : '黒',
            brand       : 'PM',
            type        : 'PR',
            point       : 2000,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'ER4-05',
            rare        : 'ER',
            name        : 'クラシックプレシャスミューズシューズ',
            imgUrl      : '/images/items/ER4-05.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'PM',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'ER4-06',
            rare        : 'ER',
            name        : 'クラシックプレシャスミューズヘアアクセ',
            imgUrl      : '/images/items/ER4-06.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'PM',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            rare        : 'ER',
          }),


          item({
            collection  : 'PT04',
            id          : 'ER4-07',
            rare        : 'ER',
            name        : 'キラッとチェックドーリーワルツワンピ',
            imgUrl      : '/images/items/ER4-07.png',
            kind        : 'ワンピース',
            color       : '水',
            brand       : 'DW',
            type        : 'LO',
            point       : 2000,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'ER4-08',
            rare        : 'ER',
            name        : 'キラッとチェックドーリーワルツシューズ',
            imgUrl      : '/images/items/ER4-08.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'DW',
            type        : 'LO',
            point       : 950,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'ER4-09',
            rare        : 'ER',
            name        : 'キラッとチェックドーリーワルツヘアアクセ',
            imgUrl      : '/images/items/ER4-09.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'DW',
            type        : 'LO',
            point       : 950,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            rare        : 'ER',
          }),


          item({
            collection  : 'PT04',
            id          : 'ER4-10',
            rare        : 'ER',
            name        : 'キラッとチェックメルティックスターワンピ',
            imgUrl      : '/images/items/ER4-10.png',
            kind        : 'ワンピース',
            color       : '水',
            brand       : 'DW',
            type        : 'LO',
            point       : 2000,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'ER4-11',
            rare        : 'ER',
            name        : 'キラッとチェックメルティックスターシューズ',
            imgUrl      : '/images/items/ER4-11.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'DW',
            type        : 'LO',
            point       : 950,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'ER4-12',
            rare        : 'ER',
            name        : 'キラッとチェックメルティックスターヘアアクセ',
            imgUrl      : '/images/items/ER4-12.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'DW',
            type        : 'LO',
            point       : 950,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            rare        : 'ER',
          }),


          // [NOTE] IR
          // ================================================================================

          item({
            collection  : 'PT04',
            id          : 'IR04-01',
            rare        : 'IR',
            name        : 'サンシャインサーカスイルミナージュドレス',
            imgUrl      : '/images/items/IR04-01.png',
            kind        : 'ワンピース',
            color       : '橙',
            brand       : 'FT',
            type        : 'NT',
            point       : 1600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'IR04-02',
            rare        : 'IR',
            name        : 'サンシャインサーカスイルミナージュシューズ',
            imgUrl      : '/images/items/IR04-02.png',
            kind        : 'シューズ',
            color       : '橙',
            brand       : 'FT',
            type        : 'NT',
            point       : 800,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'IR04-03',
            rare        : 'IR',
            name        : 'サンシャインサーカスイルミナージュヘアアクセ',
            imgUrl      : '/images/items/IR04-03.png',
            kind        : 'ヘアアクセ',
            color       : '橙',
            brand       : 'FT',
            type        : 'NT',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            rare        : 'IR',
          }),


          item({
            collection  : 'PT04',
            id          : 'IR04-04',
            rare        : 'IR',
            name        : 'サンシャインサーカスイルミナージュパープルドレス',
            imgUrl      : '/images/items/IR04-04.png',
            kind        : 'ワンピース',
            color       : '紫',
            brand       : 'FT',
            type        : 'NT',
            point       : 1600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'IR04-05',
            rare        : 'IR',
            name        : 'サンシャインサーカスイルミナージュパープルシューズ',
            imgUrl      : '/images/items/IR04-05.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'FT',
            type        : 'NT',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'IR04-06',
            rare        : 'IR',
            name        : 'サンシャインサーカスイルミナージュパープルヘアアクセ',
            imgUrl      : '/images/items/IR04-06.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'FT',
            type        : 'NT',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            rare        : 'IR',
          }),


          item({
            collection  : 'PT04',
            id          : 'IR04-07',
            rare        : 'IR',
            name        : 'サンシャインサーカスイルミナージュブルードレス',
            imgUrl      : '/images/items/IR04-07.png',
            kind        : 'ワンピース',
            color       : '水',
            brand       : 'FT',
            type        : 'NT',
            point       : 1600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'IR04-08',
            rare        : 'IR',
            name        : 'サンシャインサーカスイルミナージュブルーシューズ',
            imgUrl      : '/images/items/IR04-08.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'FT',
            type        : 'NT',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'IR04-09',
            rare        : 'IR',
            name        : 'サンシャインサーカスイルミナージュブルーヘアアクセ',
            imgUrl      : '/images/items/IR04-09.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'FT',
            type        : 'NT',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            rare        : 'IR',
          }),


          item({
            collection  : 'PT04',
            id          : 'IR04-10',
            rare        : 'IR',
            name        : 'スーパーレインボースカイイルミナージュみらいドレス',
            imgUrl      : '/images/items/IR04-10.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 1900,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'IR04-11',
            rare        : 'IR',
            name        : 'スーパーレインボースカイイルミナージュみらいシューズ',
            imgUrl      : '/images/items/IR04-11.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 850,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'IR04-12',
            rare        : 'IR',
            name        : 'スーパーレインボースカイイルミナージュみらいヘアアクセ',
            imgUrl      : '/images/items/IR04-12.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 850,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            rare        : 'IR',
          }),


          item({
            collection  : 'PT04',
            id          : 'IR04-13',
            rare        : 'IR',
            name        : 'スーパーレインボースカイイルミナージュえもドレス',
            imgUrl      : '/images/items/IR04-13.png',
            kind        : 'ワンピース',
            color       : '水',
            brand       : 'GY',
            type        : 'PO',
            point       : 1900,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'IR04-14',
            rare        : 'IR',
            name        : 'スーパーレインボースカイイルミナージュえもシューズ',
            imgUrl      : '/images/items/IR04-14.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'GY',
            type        : 'PO',
            point       : 850,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'IR04-15',
            rare        : 'IR',
            name        : 'スーパーレインボースカイイルミナージュえもヘアアクセ',
            imgUrl      : '/images/items/IR04-15.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'GY',
            type        : 'PO',
            point       : 850,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            rare        : 'IR',
          }),


          item({
            collection  : 'PT04',
            id          : 'IR04-16',
            rare        : 'IR',
            name        : 'スーパーレインボースカイイルミナージュりんかドレス',
            imgUrl      : '/images/items/IR04-16.png',
            kind        : 'ワンピース',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 1900,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'IR04-17',
            rare        : 'IR',
            name        : 'スーパーレインボースカイイルミナージュりんかシューズ',
            imgUrl      : '/images/items/IR04-17.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 850,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'IR04-18',
            rare        : 'IR',
            name        : 'スーパーレインボースカイイルミナージュりんかヘアアクセ',
            imgUrl      : '/images/items/IR04-18.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 850,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            rare        : 'IR',
          }),


          promo2020Item('IR04-19', {
            collection  : 'PT04',
            aggregation : '',
          }),
          item({
            collection  : 'PT04',
          }),
          item({
            collection  : 'PT04',
          }),
          item({
            collection  : 'PT04',
          }),


          // [NOTE] FR
          // ================================================================================

          item({
            collection  : 'PT04',
            id          : 'PT4-01',
            rare        : 'FR',
            name        : 'プリ☆ファンゆみつかいトップス',
            imgUrl      : '/images/items/PT4-01.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'MR',
            type        : 'PO',
            point       : 1100,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-02',
            rare        : 'FR',
            name        : 'プリ☆ファンゆみつかいパンツ',
            imgUrl      : '/images/items/PT4-02.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'MR',
            type        : 'PO',
            point       : 1050,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-03',
            rare        : 'FR',
            name        : 'プリ☆ファンゆみつかいシューズ',
            imgUrl      : '/images/items/PT4-03.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'MR',
            type        : 'PO',
            point       : 950,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-04',
            rare        : 'FR',
            name        : 'プリ☆ファンゆみつかいヘアアクセ',
            imgUrl      : '/images/items/PT4-04.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'MR',
            type        : 'PO',
            point       : 950,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT04',
            id          : 'PT4-05',
            rare        : 'FR',
            name        : 'プリ☆ファンおひめさまワンピ',
            imgUrl      : '/images/items/PT4-05.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : 'CH',
            type        : 'LO',
            point       : 2000,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-06',
            rare        : 'FR',
            name        : 'プリ☆ファンおひめさまシューズ',
            imgUrl      : '/images/items/PT4-06.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'CH',
            type        : 'LO',
            point       : 950,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-07',
            rare        : 'FR',
            name        : 'プリ☆ファンおひめさまヘアアクセ',
            imgUrl      : '/images/items/PT4-07.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'CH',
            type        : 'LO',
            point       : 950,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            rare        : 'FR',
          }),


          // [NOTE] PR
          // ================================================================================

          item({
            collection  : 'PT04',
            id          : 'PT4-08',
            rare        : 'PR',
            name        : 'ワンダーサーカストップス',
            imgUrl      : '/images/items/PT4-08.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'FT',
            type        : 'NT',
            point       : 900,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-09',
            rare        : 'PR',
            name        : 'ワンダーサーカスキュロット',
            imgUrl      : '/images/items/PT4-09.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'FT',
            type        : 'NT',
            point       : 800,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-10',
            rare        : 'PR',
            name        : 'ワンダーサーカスシューズ',
            imgUrl      : '/images/items/PT4-10.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'FT',
            type        : 'NT',
            point       : 850,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-11',
            rare        : 'PR',
            name        : 'ワンダーサーカスヘアアクセ',
            imgUrl      : '/images/items/PT4-11.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'FT',
            type        : 'NT',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT04',
            id          : 'PT4-12',
            rare        : 'PR',
            name        : 'マスコットソルルトップス',
            imgUrl      : '/images/items/PT4-12.png',
            kind        : 'トップス',
            color       : '橙',
            brand       : 'LP',
            type        : 'NT',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-13',
            rare        : 'PR',
            name        : 'マスコットソルルパンツ',
            imgUrl      : '/images/items/PT4-13.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : 'LP',
            type        : 'NT',
            point       : 900,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-14',
            rare        : 'PR',
            name        : 'マスコットソルルシューズ',
            imgUrl      : '/images/items/PT4-14.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'LP',
            type        : 'NT',
            point       : 850,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-15',
            rare        : 'PR',
            name        : 'マスコットソルルヘアアクセ',
            imgUrl      : '/images/items/PT4-15.png',
            kind        : 'ヘアアクセ',
            color       : '橙',
            brand       : 'LP',
            type        : 'NT',
            point       : 800,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT04',
            id          : 'PT4-16',
            rare        : 'PR',
            name        : 'ゴーゴースマイルキラッCHUトップス',
            imgUrl      : '/images/items/PT4-16.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'LP',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-17',
            rare        : 'PR',
            name        : 'ゴーゴースマイルキラッCHUスカート',
            imgUrl      : '/images/items/PT4-17.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'LP',
            type        : 'LO',
            point       : 850,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-18',
            rare        : 'PR',
            name        : 'ゴーゴースマイルキラッCHUシューズ',
            imgUrl      : '/images/items/PT4-18.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'LP',
            type        : 'LO',
            point       : 900,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-19',
            rare        : 'PR',
            name        : 'ゴーゴースマイルキラッCHUヘアアクセ',
            imgUrl      : '/images/items/PT4-19.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'LP',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT04',
            id          : 'PT4-20',
            rare        : 'PR',
            name        : 'ゴーゴースマイルラビリィトップス',
            imgUrl      : '/images/items/PT4-20.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'LP',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-21',
            rare        : 'PR',
            name        : 'ゴーゴースマイルラビリィスカート',
            imgUrl      : '/images/items/PT4-21.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'LP',
            type        : 'PO',
            point       : 850,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-22',
            rare        : 'PR',
            name        : 'ゴーゴースマイルラビリィシューズ',
            imgUrl      : '/images/items/PT4-22.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'LP',
            type        : 'PO',
            point       : 900,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-23',
            rare        : 'PR',
            name        : 'ゴーゴースマイルラビリィヘアアクセ',
            imgUrl      : '/images/items/PT4-23.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'LP',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] SR
          // ================================================================================

          item({
            collection  : 'PT04',
            id          : 'PT4-24',
            rare        : 'SR',
            name        : 'あかねロックトップス',
            imgUrl      : '/images/items/PT4-24.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'RB',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-25',
            rare        : 'SR',
            name        : 'あかねロックスカート',
            imgUrl      : '/images/items/PT4-25.png',
            kind        : 'ボトムス',
            color       : '橙',
            brand       : 'RB',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-26',
            rare        : 'SR',
            name        : 'あかねロックシューズ',
            imgUrl      : '/images/items/PT4-26.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'RB',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-27',
            rare        : 'SR',
            name        : 'あかねロックヘアアクセ',
            imgUrl      : '/images/items/PT4-27.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'RB',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT04',
            id          : 'PT4-28',
            rare        : 'SR',
            name        : 'あわあわバブルトップス',
            imgUrl      : '/images/items/PT4-28.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'MR',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-29',
            rare        : 'SR',
            name        : 'あわあわバブルスカート',
            imgUrl      : '/images/items/PT4-29.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'MR',
            type        : 'PO',
            point       : 750,
            numOwned    : { usual: 1  },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-30',
            rare        : 'SR',
            name        : 'あわあわバブルシューズ',
            imgUrl      : '/images/items/PT4-30.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'MR',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-31',
            rare        : 'SR',
            name        : 'あわあわバブルヘアアクセ',
            imgUrl      : '/images/items/PT4-31.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'MR',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT04',
            id          : 'PT4-32',
            rare        : 'SR',
            name        : 'いたずらナイトメアトップス',
            imgUrl      : '/images/items/PT4-32.png',
            kind        : 'トップス',
            color       : '黒',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-33',
            rare        : 'SR',
            name        : 'いたずらナイトメアスカート',
            imgUrl      : '/images/items/PT4-33.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-34',
            rare        : 'SR',
            name        : 'いたずらナイトメアシューズ',
            imgUrl      : '/images/items/PT4-34.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'SA',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-35',
            rare        : 'SR',
            name        : 'いたずらナイトメアヘアアクセ',
            imgUrl      : '/images/items/PT4-35.png',
            kind        : 'ヘアアクセ',
            color       : '茶',
            brand       : 'SA',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT04',
            id          : 'PT4-36',
            rare        : 'SR',
            name        : 'ムーンラビットトップス',
            imgUrl      : '/images/items/PT4-36.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'UQ',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-37',
            rare        : 'SR',
            name        : 'ムーンラビットスカート',
            imgUrl      : '/images/items/PT4-37.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'UQ',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-38',
            rare        : 'SR',
            name        : 'ムーンラビットシューズ',
            imgUrl      : '/images/items/PT4-38.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'UQ',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-39',
            rare        : 'SR',
            name        : 'ムーンラビットヘアアクセ',
            imgUrl      : '/images/items/PT4-39.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'UQ',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT04',
            id          : 'PT4-40',
            rare        : 'SR',
            name        : 'アイドルキャストナチュラルトップス',
            imgUrl      : '/images/items/PT4-40.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'LP',
            type        : 'NT',
            point       : 750,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-41',
            rare        : 'SR',
            name        : 'アイドルキャストナチュラルスカート',
            imgUrl      : '/images/items/PT4-41.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'LP',
            type        : 'NT',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-42',
            rare        : 'SR',
            name        : 'アイドルキャストナチュラルシューズ',
            imgUrl      : '/images/items/PT4-42.png',
            kind        : 'シューズ',
            color       : '橙',
            brand       : 'LP',
            type        : 'NT',
            point       : 700,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-43',
            rare        : 'SR',
            name        : 'アイドルキャストナチュラルヘアアクセ',
            imgUrl      : '/images/items/PT4-43.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'LP',
            type        : 'NT',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] SR モーリーファンタジー限定
          // ================================================================================

          item({
            collection  : 'Molly',
            id          : 'MF-63',
            rare        : 'SR',
            name        : 'ゴーゴースマイルキラッCHUオレンジトップス',
            imgUrl      : '/images/items/MF-63.png',
            kind        : 'トップス',
            color       : '橙',
            brand       : 'LP',
            type        : 'LO',
            point       : 800,
            numOwned    : { nico: 0 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Molly',
            id          : 'MF-64',
            rare        : 'SR',
            name        : 'ゴーゴースマイルキラッCHUオレンジスカート',
            imgUrl      : '/images/items/MF-64.png',
            kind        : 'ボトムス',
            color       : '橙',
            brand       : 'LP',
            type        : 'LO',
            point       : 750,
            numOwned    : { nico: 0 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Molly',
            id          : 'MF-65',
            rare        : 'SR',
            name        : 'ゴーゴースマイルキラッCHUオレンジシューズ',
            imgUrl      : '/images/items/MF-65.png',
            kind        : 'シューズ',
            color       : '橙',
            brand       : 'LP',
            type        : 'LO',
            point       : 700,
            numOwned    : { nico: 0 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Molly',
            id          : 'MF-66',
            rare        : 'SR',
            name        : 'ゴーゴースマイルキラッCHUオレンジヘアアクセ',
            imgUrl      : '/images/items/MF-66.png',
            kind        : 'ヘアアクセ',
            color       : '橙',
            brand       : 'LP',
            type        : 'LO',
            point       : 700,
            numOwned    : { nico: 0 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] R
          // ================================================================================

          item({
            collection  : 'PT04',
            id          : 'PT4-44',
            rare        : 'R',
            name        : 'マスコットパーティーナチュラルトップス',
            imgUrl      : '/images/items/PT4-44.png',
            kind        : 'トップス',
            color       : '橙',
            brand       : 'LP',
            type        : 'NT',
            point       : 600,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-45',
            rare        : 'R',
            name        : 'マスコットパーティーナチュラルスカート',
            imgUrl      : '/images/items/PT4-45.png',
            kind        : 'ボトムス',
            color       : '橙',
            brand       : 'LP',
            type        : 'NT',
            point       : 550,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-46',
            rare        : 'R',
            name        : 'マスコットパーティーナチュラルシューズ',
            imgUrl      : '/images/items/PT4-46.png',
            kind        : 'シューズ',
            color       : '金',
            brand       : 'LP',
            type        : 'NT',
            point       : 500,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-47',
            rare        : 'R',
            name        : 'マスコットパーティーナチュラルヘアアクセ',
            imgUrl      : '/images/items/PT4-47.png',
            kind        : 'ヘアアクセ',
            color       : '橙',
            brand       : 'LP',
            type        : 'NT',
            point       : 500,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT04',
            id          : 'PT4-48',
            rare        : 'R',
            name        : 'プリティーオールフレンズみあトップス',
            imgUrl      : '/images/items/PT4-48.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'PS',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-49',
            rare        : 'R',
            name        : 'プリティーオールフレンズみあスカート',
            imgUrl      : '/images/items/PT4-49.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'PS',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-50',
            rare        : 'R',
            name        : 'プリティーオールフレンズみあシューズ',
            imgUrl      : '/images/items/PT4-50.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'PS',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-51',
            rare        : 'R',
            name        : 'プリティーオールフレンズみあヘアアクセ',
            imgUrl      : '/images/items/PT4-51.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'PS',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT04',
            id          : 'PT4-52',
            rare        : 'R',
            name        : 'プリティーオールフレンズあいらトップス',
            imgUrl      : '/images/items/PT4-52.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'PS',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-53',
            rare        : 'R',
            name        : 'プリティーオールフレンズあいらスカート',
            imgUrl      : '/images/items/PT4-53.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'PS',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-54',
            rare        : 'R',
            name        : 'プリティーオールフレンズあいらシューズ',
            imgUrl      : '/images/items/PT4-54.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'PS',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-55',
            rare        : 'R',
            name        : 'プリティーオールフレンズあいらヘアアクセ',
            imgUrl      : '/images/items/PT4-55.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'PS',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT04',
            id          : 'PT4-56',
            rare        : 'R',
            name        : 'プリティーオールフレンズなるトップス',
            imgUrl      : '/images/items/PT4-56.png',
            kind        : 'トップス',
            color       : '黒',
            brand       : 'PS',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-57',
            rare        : 'R',
            name        : 'プリティーオールフレンズなるスカート',
            imgUrl      : '/images/items/PT4-57.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'PS',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-58',
            rare        : 'R',
            name        : 'プリティーオールフレンズなるシューズ',
            imgUrl      : '/images/items/PT4-58.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'PS',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-59',
            rare        : 'R',
            name        : 'プリティーオールフレンズなるヘアアクセ',
            imgUrl      : '/images/items/PT4-59.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'PS',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT04',
            id          : 'PT4-60',
            rare        : 'R',
            name        : 'マーガレットオフショルトップス',
            imgUrl      : '/images/items/PT4-60.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'FT',
            type        : 'NT',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-61',
            rare        : 'R',
            name        : 'マーガレットキュロット',
            imgUrl      : '/images/items/PT4-61.png',
            kind        : 'ボトムス',
            color       : '橙',
            brand       : 'FT',
            type        : 'NT',
            point       : 550,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-62',
            rare        : 'R',
            name        : 'マーガレットシューズ',
            imgUrl      : '/images/items/PT4-62.png',
            kind        : 'シューズ',
            color       : '茶',
            brand       : 'FT',
            type        : 'NT',
            point       : 500,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-63',
            rare        : 'R',
            name        : 'マーガレットヘアアクセ',
            imgUrl      : '/images/items/PT4-63.png',
            kind        : 'ヘアアクセ',
            color       : '茶',
            brand       : 'FT',
            type        : 'NT',
            point       : 500,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT04',
            id          : 'PT4-64',
            rare        : 'R',
            name        : 'コルセットデニムトップス',
            imgUrl      : '/images/items/PT4-64.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'UQ',
            type        : 'CO',
            point       : 550,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-65',
            rare        : 'R',
            name        : 'コルセットデニムスカート',
            imgUrl      : '/images/items/PT4-65.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : 'UQ',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-66',
            rare        : 'R',
            name        : 'コルセットデニムシューズ',
            imgUrl      : '/images/items/PT4-66.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'UQ',
            type        : 'CO',
            point       : 450,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-67',
            rare        : 'R',
            name        : 'コルセットデニムヘアアクセ',
            imgUrl      : '/images/items/PT4-67.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'UQ',
            type        : 'CO',
            point       : 450,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] N
          // ================================================================================

          item({
            collection  : 'PT04',
            id          : 'PT4-68',
            rare        : 'N',
            name        : 'スイートレースハイネック',
            imgUrl      : '/images/items/PT4-68.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 450,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-69',
            rare        : 'N',
            name        : 'スイートレーススカート',
            imgUrl      : '/images/items/PT4-69.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 400,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-70',
            rare        : 'N',
            name        : 'スイートレースシューズ',
            imgUrl      : '/images/items/PT4-70.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 350,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-71',
            rare        : 'N',
            name        : 'スイートレースヘアアクセ',
            imgUrl      : '/images/items/PT4-71.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 350,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT04',
            id          : 'PT4-72',
            rare        : 'N',
            name        : 'オータムシフォンワンピ',
            imgUrl      : '/images/items/PT4-72.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : 'PS',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-73',
            rare        : 'N',
            name        : 'オータムシフォンシューズ',
            imgUrl      : '/images/items/PT4-73.png',
            kind        : 'シューズ',
            color       : '茶',
            brand       : 'PS',
            type        : 'LO',
            point       : 350,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-74',
            rare        : 'N',
            name        : 'オータムシフォンヘアアクセ',
            imgUrl      : '/images/items/PT4-74.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'PS',
            type        : 'LO',
            point       : 350,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            rare        : 'N',
          }),


          item({
            collection  : 'PT04',
            id          : 'PT4-75',
            rare        : 'N',
            name        : 'クリスマスサンタネイビートップス',
            imgUrl      : '/images/items/PT4-75.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'SH',
            type        : 'LO',
            point       : 450,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-76',
            rare        : 'N',
            name        : 'クリスマスサンタネイビースカート',
            imgUrl      : '/images/items/PT4-76.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'SH',
            type        : 'LO',
            point       : 400,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-77',
            rare        : 'N',
            name        : 'クリスマスサンタネイビーシューズ',
            imgUrl      : '/images/items/PT4-77.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'SH',
            type        : 'LO',
            point       : 350,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-78',
            rare        : 'N',
            name        : 'クリスマスサンタネイビーヘアアクセ',
            imgUrl      : '/images/items/PT4-78.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'SH',
            type        : 'LO',
            point       : 350,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT04',
            id          : 'PT4-79',
            rare        : 'N',
            name        : 'スノーファーピンクロゼワンピ',
            imgUrl      : '/images/items/PT4-79.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : 'DW',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-80',
            rare        : 'N',
            name        : 'スノーファーピンクロゼシューズ',
            imgUrl      : '/images/items/PT4-80.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'DW',
            type        : 'LO',
            point       : 350,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-81',
            rare        : 'N',
            name        : 'スノーファーピンクロゼヘアアクセ',
            imgUrl      : '/images/items/PT4-81.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'DW',
            type        : 'LO',
            point       : 350,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            rare        : 'N',
          }),


          item({
            collection  : 'PT04',
            id          : 'PT4-82',
            rare        : 'N',
            name        : 'フラワーパターングリーンワンピ',
            imgUrl      : '/images/items/PT4-82.png',
            kind        : 'ワンピース',
            color       : '緑',
            brand       : 'SH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-83',
            rare        : 'N',
            name        : 'フラワーパターングリーンシューズ',
            imgUrl      : '/images/items/PT4-83.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 350,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            id          : 'PT4-84',
            rare        : 'N',
            name        : 'フラワーパターングリーンヘアアクセ',
            imgUrl      : '/images/items/PT4-84.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'SH',
            type        : 'LO',
            point       : 350,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT04',
            rare        : 'N',
          }),


          // [NOTE] パシャッとアイテム
          // ================================================================================



          // [NOTE] プレゼントボックス
          // ================================================================================

          item({
            collection  : 'PBox',
            id          : 'PB-91',
            rare        : 'SR',
            name        : 'クリスマスパーティーまっかなトップス',
            imgUrl      : '/images/items/PB-91.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : '',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PBox',
            id          : 'PB-92',
            rare        : 'SR',
            name        : 'クリスマスパーティーまっかなスカート',
            imgUrl      : '/images/items/PB-92.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : '',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PBox',
            id          : 'PB-93',
            rare        : 'SR',
            name        : 'クリスマスパーティーまっかなシューズ',
            imgUrl      : '/images/items/PB-93.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PBox',
            id          : 'PB-94',
            rare        : 'SR',
            name        : 'クリスマスパーティーまっかなヘアアクセ',
            imgUrl      : '/images/items/PB-94.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PBox',
            id          : 'PB-95',
            rare        : 'SR',
            name        : 'おしょうがつこんいろワンピ',
            imgUrl      : '/images/items/PB-95.png',
            kind        : 'ワンピース',
            color       : '青',
            brand       : '',
            type        : 'CO',
            point       : 1300,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PBox',
            id          : 'PB-96',
            rare        : 'SR',
            name        : 'おしょうがつこんいろシューズ',
            imgUrl      : '/images/items/PB-96.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : '',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PBox',
            id          : 'PB-97',
            rare        : 'SR',
            name        : 'おしょうがつこんいろヘアアクセ',
            imgUrl      : '/images/items/PB-97.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : '',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PBox',
            kind        : 'パシャッとアイテム',
          }),


          externalPashaItem('PCH2-80', { collection: 'PBox' }),
          externalPashaItem('PCH4-95', { collection: 'PBox' }),
          item({
            collection  : 'PBox',
            id          : 'PB-98',
            rare        : 'SR',
            name        : 'かいほうオトメ ヴァルキュリアのかぎ',
            imgUrl      : '/images/items/PB-98.png',
            kind        : 'パシャッとアイテム',
            color       : '金',
            brand       : '',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PBox',
            kind        : 'パシャッとアイテム',
          }),


          // [NOTE] サンリオキャラクターズチャンネル
          // ================================================================================

          item({
            collection  : 'Sanrio',
            id          : 'PT4-99',
            rare        : 'SR',
            name        : 'シナモロールおでかけワンピ',
            imgUrl      : '/images/items/PT4-99.png',
            kind        : 'ワンピース',
            color       : '水',
            brand       : '',
            type        : 'PR',
            point       : 1300,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Sanrio',
            id          : 'PT4-100',
            rare        : 'SR',
            name        : 'シナモロールおでかけシューズ',
            imgUrl      : '/images/items/PT4-100.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Sanrio',
            id          : 'PT4-101',
            rare        : 'SR',
            name        : 'シナモロールおでかけヘアアクセ',
            imgUrl      : '/images/items/PT4-101.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Sanrio',
            rare        : 'SR',
          }),


          item({
            collection  : 'Sanrio',
            id          : 'PT4-102',
            rare        : 'SR',
            name        : 'リトルツインスターズおでかけワンピ',
            imgUrl      : '/images/items/PT4-102.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Sanrio',
            id          : 'PT4-103',
            rare        : 'SR',
            name        : 'リトルツインスターズおでかけシューズ',
            imgUrl      : '/images/items/PT4-103.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Sanrio',
            id          : 'PT4-104',
            rare        : 'SR',
            name        : 'リトルツインスターズおでかけヘアアクセ',
            imgUrl      : '/images/items/PT4-104.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Sanrio',
            rare        : 'SR',
          }),


          item({
            collection  : 'Sanrio',
            id          : 'PT4-105',
            rare        : 'SR',
            name        : 'リトルツインスターズパネル',
            imgUrl      : '/images/items/PT4-105.png',
            kind        : 'パシャッとアイテム',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Sanrio',
            rare        : 'SR',
          }),
          item({
            collection  : 'Sanrio',
            rare        : 'SR',
          }),
          item({
            collection  : 'Sanrio',
            rare        : 'SR',
          }),



          // [NOTE] ラブパトリーナチャンネル
          // ================================================================================

          item({
            collection  : 'LovePato',
            id          : 'PT4-106',
            rare        : 'SR',
            name        : 'ラブパトシャインソラワンピ',
            imgUrl      : '/images/items/PT4-106.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 1300,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'LovePato',
            id          : 'PT4-107',
            rare        : 'SR',
            name        : 'ラブパトシャインソラシューズ',
            imgUrl      : '/images/items/PT4-107.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'LovePato',
            id          : 'PT4-108',
            rare        : 'SR',
            name        : 'ラブパトシャインソラヘアアクセ',
            imgUrl      : '/images/items/PT4-108.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'LovePato',
            rare        : 'SR',
          }),


          // [NOTE] いたずらナイトメアチャンネル
          // ================================================================================

          item({
            collection  : 'NightMare',
            id          : 'PT4-91',
            rare        : 'SR',
            name        : 'いたずらナイトメアパープルトップス',
            imgUrl      : '/images/items/PT4-91.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'NightMare',
            id          : 'PT4-92',
            rare        : 'SR',
            name        : 'いたずらナイトメアパープルスカート',
            imgUrl      : '/images/items/PT4-92.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'NightMare',
            id          : 'PT4-93',
            rare        : 'SR',
            name        : 'いたずらナイトメアパープルシューズ',
            imgUrl      : '/images/items/PT4-93.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'NightMare',
            id          : 'PT4-94',
            rare        : 'SR',
            name        : 'いたずらナイトメアパープルヘアアクセ',
            imgUrl      : '/images/items/PT4-94.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'NightMare',
            id          : 'PT4-95',
            rare        : 'SR',
            name        : 'いたずらナイトメアブルートップス',
            imgUrl      : '/images/items/PT4-95.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : 'SA',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'NightMare',
            id          : 'PT4-96',
            rare        : 'SR',
            name        : 'いたずらナイトメアブルースカート',
            imgUrl      : '/images/items/PT4-96.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'NightMare',
            id          : 'PT4-97',
            rare        : 'SR',
            name        : 'いたずらナイトメアブルーシューズ',
            imgUrl      : '/images/items/PT4-97.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : 'SA',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'NightMare',
            id          : 'PT4-98',
            rare        : 'SR',
            name        : 'いたずらナイトメアブルーヘアアクセ',
            imgUrl      : '/images/items/PT4-98.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] ハッピーレア大量発生チャンネル
          // ================================================================================

          externalHR('J4-01', { collection: 'MassiveHR' }),
          externalHR('J4-02', { collection: 'MassiveHR' }),
          externalHR('J4-03', { collection: 'MassiveHR' }),
          item({ rare: 'HR', collection: 'MassiveHR' }),

          externalHR('J4-82', { collection: 'MassiveHR' }),
          externalHR('J4-83', { collection: 'MassiveHR' }),
          externalHR('J4-84', { collection: 'MassiveHR' }),
          item({ rare: 'HR', collection: 'MassiveHR' }),

          externalHR('J4-04', { collection: 'MassiveHR' }),
          externalHR('J4-05', { collection: 'MassiveHR' }),
          externalHR('J4-06', { collection: 'MassiveHR' }),
          item({ rare: 'HR', collection: 'MassiveHR' }),

          externalHR('J4-85', { collection: 'MassiveHR' }),
          externalHR('J4-86', { collection: 'MassiveHR' }),
          externalHR('J4-87', { collection: 'MassiveHR' }),
          item({ rare: 'HR', collection: 'MassiveHR' }),

          externalHR('J1-01', { collection: 'MassiveHR' }),
          externalHR('J1-02', { collection: 'MassiveHR' }),
          externalHR('J1-03', { collection: 'MassiveHR' }),
          item({ rare: 'HR', collection: 'MassiveHR' }),

          externalHR('J1-65', { collection: 'MassiveHR' }),
          externalHR('J1-66', { collection: 'MassiveHR' }),
          externalHR('J1-67', { collection: 'MassiveHR' }),
          item({ rare: 'HR', collection: 'MassiveHR' }),

          externalHR('J5-09', { collection: 'MassiveHR' }),
          externalHR('J5-10', { collection: 'MassiveHR' }),
          externalHR('J5-11', { collection: 'MassiveHR' }),
          item({ rare: 'HR', collection: 'MassiveHR' }),

          externalHR('J5-12', { collection: 'MassiveHR' }),
          externalHR('J5-13', { collection: 'MassiveHR' }),
          externalHR('J5-14', { collection: 'MassiveHR' }),
          item({ rare: 'HR', collection: 'MassiveHR' }),

          externalHR('J5-83', { collection: 'MassiveHR' }),
          externalHR('J5-84', { collection: 'MassiveHR' }),
          externalHR('J5-85', { collection: 'MassiveHR' }),
          item({ rare: 'HR', collection: 'MassiveHR' }),

          externalHR('J5-86', { collection: 'MassiveHR' }),
          externalHR('J5-87', { collection: 'MassiveHR' }),
          externalHR('J5-88', { collection: 'MassiveHR' }),
          item({ rare: 'HR', collection: 'MassiveHR' }),


          // [NOTE] ニコチケ PR
          // ================================================================================

          item({
            collection  : 'Nico',
            id          : 'NC-PT4-01',
            rare        : 'PR',
            name        : 'ゴーゴースマイルメルパントップス',
            imgUrl      : '/images/items/NC-PT4-01.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'LP',
            type        : 'CO',
            point       : 850,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-02',
            rare        : 'PR',
            name        : 'ゴーゴースマイルメルパンスカート',
            imgUrl      : '/images/items/NC-PT4-02.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'LP',
            type        : 'CO',
            point       : 800,
            aggregation : 'NC-PT4-01',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-03',
            rare        : 'PR',
            name        : 'ゴーゴースマイルメルパンシューズ',
            imgUrl      : '/images/items/NC-PT4-03.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'LP',
            type        : 'CO',
            point       : 900,
            aggregation : 'NC-PT4-01',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-04',
            rare        : 'PR',
            name        : 'ゴーゴースマイルメルパンヘアアクセ',
            imgUrl      : '/images/items/NC-PT4-04.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'LP',
            type        : 'CO',
            point       : 800,
            aggregation : 'NC-PT4-01',
          }),


          item({
            collection  : 'Nico',
            id          : 'NC-PT4-05',
            rare        : 'PR',
            name        : 'ワンダーサーカスクラシックトップス',
            imgUrl      : '/images/items/NC-PT4-05.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'FT',
            type        : 'NT',
            point       : 900,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-06',
            rare        : 'PR',
            name        : 'ワンダーサーカスクラシックスカート',
            imgUrl      : '/images/items/NC-PT4-06.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'FT',
            type        : 'NT',
            point       : 850,
            aggregation : 'NC-PT4-05',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-07',
            rare        : 'PR',
            name        : 'ワンダーサーカスクラシックシューズ',
            imgUrl      : '/images/items/NC-PT4-07.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'FT',
            type        : 'NT',
            point       : 800,
            aggregation : 'NC-PT4-05',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-08',
            rare        : 'PR',
            name        : 'ワンダーサーカスクラシックヘアアクセ',
            imgUrl      : '/images/items/NC-PT4-08.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'FT',
            type        : 'NT',
            point       : 800,
            aggregation : 'NC-PT4-05',
          }),


          // [NOTE] ニコチケ SR
          // ================================================================================

          item({
            collection  : 'Nico',
            id          : 'NC-PT4-09',
            rare        : 'SR',
            name        : 'ツインラブハートパープルトップス',
            imgUrl      : '/images/items/NC-PT4-09.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'GY',
            type        : 'PO',
            point       : 700,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-10',
            rare        : 'SR',
            name        : 'ツインラブハートパープルスカート',
            imgUrl      : '/images/items/NC-PT4-10.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            aggregation : 'NC-PT4-09',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-11',
            rare        : 'SR',
            name        : 'ツインラブハートパープルシューズ',
            imgUrl      : '/images/items/NC-PT4-11.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'GY',
            type        : 'PO',
            point       : 650,
            aggregation : 'NC-PT4-09',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-12',
            rare        : 'SR',
            name        : 'ツインラブハートパープルヘアアクセ',
            imgUrl      : '/images/items/NC-PT4-12.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'GY',
            type        : 'PO',
            point       : 650,
            aggregation : 'NC-PT4-09',
          }),


          item({
            collection  : 'Nico',
            id          : 'NC-PT4-13',
            rare        : 'SR',
            name        : 'ツインラブハートオレンジトップス',
            imgUrl      : '/images/items/NC-PT4-13.png',
            kind        : 'トップス',
            color       : '橙',
            brand       : 'DW',
            type        : 'LO',
            point       : 750,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-14',
            rare        : 'SR',
            name        : 'ツインラブハートオレンジスカート',
            imgUrl      : '/images/items/NC-PT4-14.png',
            kind        : 'ボトムス',
            color       : '橙',
            brand       : 'DW',
            type        : 'LO',
            point       : 700,
            aggregation : 'NC-PT4-13',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-15',
            rare        : 'SR',
            name        : 'ツインラブハートオレンジシューズ',
            imgUrl      : '/images/items/NC-PT4-15.png',
            kind        : 'シューズ',
            color       : '橙',
            brand       : 'DW',
            type        : 'LO',
            point       : 650,
            aggregation : 'NC-PT4-13',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-16',
            rare        : 'SR',
            name        : 'ツインラブハートオレンジヘアアクセ',
            imgUrl      : '/images/items/NC-PT4-16.png',
            kind        : 'ヘアアクセ',
            color       : '橙',
            brand       : 'DW',
            type        : 'LO',
            point       : 650,
            aggregation : 'NC-PT4-13',
          }),


          item({
            collection  : 'Nico',
            id          : 'NC-PT4-17',
            rare        : 'SR',
            name        : 'いたずらナイトメアピンクトップス',
            imgUrl      : '/images/items/NC-PT4-17.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'SA',
            type        : 'CO',
            point       : 750,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-18',
            rare        : 'SR',
            name        : 'いたずらナイトメアピンクスカート',
            imgUrl      : '/images/items/NC-PT4-18.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 650,
            aggregation : 'NC-PT4-17',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-19',
            rare        : 'SR',
            name        : 'いたずらナイトメアピンクシューズ',
            imgUrl      : '/images/items/NC-PT4-19.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            aggregation : 'NC-PT4-17',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-20',
            rare        : 'SR',
            name        : 'いたずらナイトメアピンクヘアアクセ',
            imgUrl      : '/images/items/NC-PT4-20.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 650,
            aggregation : 'NC-PT4-17',
          }),


          item({
            collection  : 'Nico',
            id          : 'NC-PT4-21',
            rare        : 'SR',
            name        : 'あわあわバブルブルートップス',
            imgUrl      : '/images/items/NC-PT4-21.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'MR',
            type        : 'PO',
            point       : 700,
            numOwned    : { nico: 3 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-22',
            rare        : 'SR',
            name        : 'あわあわバブルブルースカート',
            imgUrl      : '/images/items/NC-PT4-22.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'MR',
            type        : 'PO',
            point       : 750,
            aggregation : 'NC-PT4-21',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-23',
            rare        : 'SR',
            name        : 'あわあわバブルブルーシューズ',
            imgUrl      : '/images/items/NC-PT4-23.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'MR',
            type        : 'PO',
            point       : 650,
            aggregation : 'NC-PT4-21',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-24',
            rare        : 'SR',
            name        : 'あわあわバブルブルーヘアアクセ',
            imgUrl      : '/images/items/NC-PT4-24.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'MR',
            type        : 'PO',
            point       : 650,
            aggregation : 'NC-PT4-21',
          }),


          // [NOTE] ニコチケ R
          // ================================================================================

          item({
            collection  : 'Nico',
            id          : 'NC-PT4-25',
            rare        : 'R',
            name        : 'ドラマティックリボントップス',
            imgUrl      : '/images/items/NC-PT4-25.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'DW',
            type        : 'LO',
            point       : 600,
            numOwned    : { nico: 0 },
            numReleased : { nico: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-26',
            rare        : 'R',
            name        : 'ドラマティックリボンスカート',
            imgUrl      : '/images/items/NC-PT4-26.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'DW',
            type        : 'LO',
            point       : 550,
            aggregation : 'NC-PT4-25',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-27',
            rare        : 'R',
            name        : 'ドラマティックリボンシューズ',
            imgUrl      : '/images/items/NC-PT4-27.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'DW',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-PT4-25',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-28',
            rare        : 'R',
            name        : 'ドラマティックリボンヘアアクセ',
            imgUrl      : '/images/items/NC-PT4-28.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'DW',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-PT4-25',
          }),


          item({
            collection  : 'Nico',
            id          : 'NC-PT4-29',
            rare        : 'R',
            name        : 'ドラマティックリボンピンクトップス',
            imgUrl      : '/images/items/NC-PT4-29.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'DW',
            type        : 'LO',
            point       : 600,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-30',
            rare        : 'R',
            name        : 'ドラマティックリボンピンクスカート',
            imgUrl      : '/images/items/NC-PT4-30.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'DW',
            type        : 'LO',
            point       : 550,
            aggregation : 'NC-PT4-29',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-31',
            rare        : 'R',
            name        : 'ドラマティックリボンピンクシューズ',
            imgUrl      : '/images/items/NC-PT4-31.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'DW',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-PT4-29',
          }),

          item({
            collection  : 'Nico',
            id          : 'NC-PT4-32',
            rare        : 'R',
            name        : 'ドラマティックリボンピンクヘアアクセ',
            imgUrl      : '/images/items/NC-PT4-32.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'DW',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-PT4-29',
          }),


          item({
            collection  : 'Nico',
            id          : 'NC-PT4-33',
            rare        : 'R',
            name        : 'ドラマティックリボンパープルトップス',
            imgUrl      : '/images/items/NC-PT4-33.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'DW',
            type        : 'LO',
            point       : 600,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-34',
            rare        : 'R',
            name        : 'ドラマティックリボンパープルスカート',
            imgUrl      : '/images/items/NC-PT4-34.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'DW',
            type        : 'LO',
            point       : 550,
            aggregation : 'NC-PT4-33',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-35',
            rare        : 'R',
            name        : 'ドラマティックリボンパープルシューズ',
            imgUrl      : '/images/items/NC-PT4-35.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'DW',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-PT4-33',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-36',
            rare        : 'R',
            name        : 'ドラマティックリボンパープルヘアアクセ',
            imgUrl      : '/images/items/NC-PT4-36.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'DW',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-PT4-33',
          }),


          item({
            collection  : 'Nico',
            id          : 'NC-PT4-37',
            rare        : 'R',
            name        : 'ネオンドロップフルスイングワンピ',
            imgUrl      : '/images/items/NC-PT4-37.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 1000,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-38',
            rare        : 'R',
            name        : 'ネオンドロップフルスイングシューズ',
            imgUrl      : '/images/items/NC-PT4-38.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 500,
            aggregation : 'NC-PT4-37',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-39',
            rare        : 'R',
            name        : 'ネオンドロップフルスイングヘアアクセ',
            imgUrl      : '/images/items/NC-PT4-39.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 500,
            aggregation : 'NC-PT4-37',
          }),
          item({
            collection  : 'Nico',
            rare        : 'R',
          }),


          item({
            collection  : 'Nico',
            id          : 'NC-PT4-40',
            rare        : 'R',
            name        : 'ネオンドロップフルスイングイエローワンピ',
            imgUrl      : '/images/items/NC-PT4-40.png',
            kind        : 'ワンピース',
            color       : '黄',
            brand       : 'GY',
            type        : 'PO',
            point       : 1000,
            numOwned    : { nico: 0 },
            numReleased : { nico: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-41',
            rare        : 'R',
            name        : 'ネオンドロップフルスイングイエローシューズ',
            imgUrl      : '/images/items/NC-PT4-41.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'GY',
            type        : 'PO',
            point       : 500,
            aggregation : 'NC-PT4-40',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-42',
            rare        : 'R',
            name        : 'ネオンドロップフルスイングイエローヘアアクセ',
            imgUrl      : '/images/items/NC-PT4-42.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'GY',
            type        : 'PO',
            point       : 500,
            aggregation : 'NC-PT4-40',
          }),
          item({
            collection  : 'Nico',
            rare        : 'R',
          }),


          item({
            collection  : 'Nico',
            id          : 'NC-PT4-43',
            rare        : 'R',
            name        : 'ネオンドロップフルスインググリーンワンピ',
            imgUrl      : '/images/items/NC-PT4-43.png',
            kind        : 'ワンピース',
            color       : '緑',
            brand       : 'GY',
            type        : 'PO',
            point       : 1000,
            numOwned    : { nico: 3 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-44',
            rare        : 'R',
            name        : 'ネオンドロップフルスインググリーンシューズ',
            imgUrl      : '/images/items/NC-PT4-44.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : 'GY',
            type        : 'PO',
            point       : 500,
            aggregation : 'NC-PT4-43',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-45',
            rare        : 'R',
            name        : 'ネオンドロップフルスインググリーンヘアアクセ',
            imgUrl      : '/images/items/NC-PT4-45.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'GY',
            type        : 'PO',
            point       : 500,
            aggregation : 'NC-PT4-43',
          }),
          item({
            collection  : 'Nico',
            rare        : 'R',
          }),


          item({
            collection  : 'Nico',
            id          : 'NC-PT4-46',
            rare        : 'R',
            name        : 'ゆめみるポッピンワンピ',
            imgUrl      : '/images/items/NC-PT4-46.png',
            kind        : 'ワンピース',
            color       : '黄',
            brand       : 'MR',
            type        : 'PO',
            point       : 1000,
            numOwned    : { nico: 3 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-47',
            rare        : 'R',
            name        : 'ゆめみるポッピンシューズ',
            imgUrl      : '/images/items/NC-PT4-47.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'MR',
            type        : 'PO',
            point       : 500,
            aggregation : 'NC-PT4-46',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-48',
            rare        : 'R',
            name        : 'ゆめみるポッピンヘアアクセ',
            imgUrl      : '/images/items/NC-PT4-48.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'MR',
            type        : 'PO',
            point       : 500,
            aggregation : 'NC-PT4-46',
          }),
          item({
            collection  : 'Nico',
            rare        : 'R',
          }),


          item({
            collection  : 'Nico',
            id          : 'NC-PT4-49',
            rare        : 'R',
            name        : 'ゆめみるトリッキーワンピ',
            imgUrl      : '/images/items/NC-PT4-49.png',
            kind        : 'ワンピース',
            color       : '青',
            brand       : 'MR',
            type        : 'PO',
            point       : 1000,
            numOwned    : { nico: 0 },
            numReleased : { nico: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-50',
            rare        : 'R',
            name        : 'ゆめみるトリッキーシューズ',
            imgUrl      : '/images/items/NC-PT4-50.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'MR',
            type        : 'PO',
            point       : 500,
            aggregation : 'NC-PT4-49',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-51',
            rare        : 'R',
            name        : 'ゆめみるトリッキーヘアアクセ',
            imgUrl      : '/images/items/NC-PT4-51.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'MR',
            type        : 'PO',
            point       : 500,
            aggregation : 'NC-PT4-49',
          }),
          item({
            collection  : 'Nico',
            rare        : 'R',
          }),


          item({
            collection  : 'Nico',
            id          : 'NC-PT4-52',
            rare        : 'R',
            name        : 'ネオングラデクーリッシュトップス',
            imgUrl      : '/images/items/NC-PT4-52.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'DS',
            type        : 'CO',
            point       : 600,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-53',
            rare        : 'R',
            name        : 'ネオングラデクーリッシュスカート',
            imgUrl      : '/images/items/NC-PT4-53.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'DS',
            type        : 'CO',
            point       : 550,
            aggregation : 'NC-PT4-52',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-54',
            rare        : 'R',
            name        : 'ネオングラデクーリッシュシューズ',
            imgUrl      : '/images/items/NC-PT4-54.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'DS',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-PT4-52',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-55',
            rare        : 'R',
            name        : 'ネオングラデクーリッシュヘアアクセ',
            imgUrl      : '/images/items/NC-PT4-55.png',
            kind        : 'ヘアアクセ',
            color       : '金',
            brand       : 'DS',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-PT4-52',
          }),


          item({
            collection  : 'Nico',
            id          : 'NC-PT4-56',
            rare        : 'R',
            name        : 'ダンスフロアレトロワンピ',
            imgUrl      : '/images/items/NC-PT4-56.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : 'UQ',
            type        : 'CO',
            point       : 1000,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-57',
            rare        : 'R',
            name        : 'ダンスフロアレトロシューズ',
            imgUrl      : '/images/items/NC-PT4-57.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'UQ',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-PT4-56',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-58',
            rare        : 'R',
            name        : 'ダンスフロアレトロヘアアクセ',
            imgUrl      : '/images/items/NC-PT4-58.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'UQ',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-PT4-56',
          }),
          item({
            collection  : 'Nico',
            rare        : 'R',
          }),


          item({
            collection  : 'Nico',
            id          : 'NC-PT4-59',
            rare        : 'R',
            name        : 'ボリュームファーグレープトップス',
            imgUrl      : '/images/items/NC-PT4-59.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'PM',
            type        : 'PR',
            point       : 600,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-60',
            rare        : 'R',
            name        : 'ボリュームファーグリーンスカート',
            imgUrl      : '/images/items/NC-PT4-60.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'PM',
            type        : 'PR',
            point       : 550,
            aggregation : 'NC-PT4-59',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-61',
            rare        : 'R',
            name        : 'ボリュームファーグレープシューズ',
            imgUrl      : '/images/items/NC-PT4-61.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'PM',
            type        : 'PR',
            point       : 500,
            aggregation : 'NC-PT4-59',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-62',
            rare        : 'R',
            name        : 'ボリュームファーグレープヘアアクセ',
            imgUrl      : '/images/items/NC-PT4-62.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'PM',
            type        : 'PR',
            point       : 500,
            aggregation : 'NC-PT4-59',
          }),


          item({
            collection  : 'Nico',
            id          : 'NC-PT4-63',
            rare        : 'R',
            name        : 'チェッカーガールレッドトップス',
            imgUrl      : '/images/items/NC-PT4-63.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 600,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-64',
            rare        : 'R',
            name        : 'チェッカーガールレッドスカート',
            imgUrl      : '/images/items/NC-PT4-64.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 550,
            aggregation : 'NC-PT4-63',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-65',
            rare        : 'R',
            name        : 'チェッカーガールレッドシューズ',
            imgUrl      : '/images/items/NC-PT4-65.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 500,
            aggregation : 'NC-PT4-63',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-66',
            rare        : 'R',
            name        : 'チェッカーガールレッドヘアアクセ',
            imgUrl      : '/images/items/NC-PT4-66.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 500,
            aggregation : 'NC-PT4-63',
          }),


          item({
            collection  : 'Nico',
            id          : 'NC-PT4-67',
            rare        : 'R',
            name        : 'ホワイトスワンアンジュトップス',
            imgUrl      : '/images/items/NC-PT4-67.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'PM',
            type        : 'PR',
            point       : 600,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-68',
            rare        : 'R',
            name        : 'ホワイトスワンアンジュスカート',
            imgUrl      : '/images/items/NC-PT4-68.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : 'PM',
            type        : 'PR',
            point       : 550,
            aggregation : 'NC-PT4-67',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-69',
            rare        : 'R',
            name        : 'ホワイトスワンアンジュシューズ',
            imgUrl      : '/images/items/NC-PT4-69.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'PM',
            type        : 'PR',
            point       : 500,
            aggregation : 'NC-PT4-67',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-70',
            rare        : 'R',
            name        : 'ホワイトスワンアンジュヘアアクセ',
            imgUrl      : '/images/items/NC-PT4-70.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'PM',
            type        : 'PR',
            point       : 500,
            aggregation : 'NC-PT4-67',
          }),


          item({
            collection  : 'Nico',
            id          : 'NC-PT4-71',
            rare        : 'R',
            name        : 'メルヘンナチュラルバードワンピ',
            imgUrl      : '/images/items/NC-PT4-71.png',
            kind        : 'ワンピース',
            color       : '緑',
            brand       : 'FT',
            type        : 'NT',
            point       : 1000,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-72',
            rare        : 'R',
            name        : 'メルヘンナチュラルバードシューズ',
            imgUrl      : '/images/items/NC-PT4-72.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'FT',
            type        : 'NT',
            point       : 500,
            aggregation : 'NC-PT4-71',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT4-73',
            rare        : 'R',
            name        : 'メルヘンナチュラルバードヘアアクセ',
            imgUrl      : '/images/items/NC-PT4-73.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'FT',
            type        : 'NT',
            point       : 500,
            aggregation : 'NC-PT4-71',
          }),
          item({
            collection  : 'Nico',
            rare        : 'R',
          }),


        ]
      }
    },

    computed: {
      itemsFiltered () {
        const { excepts, items } = this
        return excepts.length
          ? items.filter(item => !excepts.includes(item.collection) )
          : items
      },

      itemsMaJor () {
        const { major, itemsFiltered, itemsPasha } = this
        return itemsFiltered.filter(item => major.includes(item.collection) && !itemsPasha.includes(item))
      },

      itemsHR () {
        return _.where(this.itemsFiltered, { rare: 'HR' })
      },

      itemsIR () {
        return _.where(this.itemsMaJor, { rare: 'IR' })
      },

      itemsWR () {
        return _.where(this.itemsMaJor, { rare: 'WR' })
      },

      itemsER () {
        return _.where(this.itemsMaJor, { rare: 'ER' })
      },

      itemsFR () {
        return _.where(this.itemsMaJor, { rare: 'FR' })
      },

      itemsPR () {
        return _.where(this.itemsMaJor, { rare: 'PR' })
      },

      itemsSR () {
        return _.where(this.itemsMaJor, { rare: 'SR' })
      },

      itemsR () {
        return _.where(this.itemsMaJor, { rare: 'R' })
      },

      itemsN () {
        return _.where(this.itemsMaJor, { rare: 'N' })
      },

      itemsNico () {
        return _.where(this.itemsFiltered, { collection: 'Nico' })
      },

      itemsNicoPR () {
        return _.where(this.itemsNico, { rare: 'PR' })
      },

      itemsNicoSR () {
        return _.where(this.itemsNico, { rare: 'SR' })
      },

      itemsNicoR () {
        return _.where(this.itemsNico, { rare: 'R' })
      },

      itemsNicoN () {
        return _.where(this.itemsNico, { rare: 'N' })
      },

      itemsPasha () {
        return _.where(this.itemsFiltered, { kind: 'パシャッとアイテム' }).filter(item => this.major.includes(item.collection) )
      },

      itemsPBox () {
        return _.where(this.itemsFiltered, { collection: 'PBox' })
      },

      itemsMolly () {
        return _.where(this.itemsFiltered, { collection: 'Molly' })
      },

      itemsSanrio () {
        return _.where(this.itemsFiltered, { collection: 'Sanrio' })
      },

      itemsLovePato () {
        return _.where(this.itemsFiltered, { collection: 'LovePato' })
      },

      itemsNightMare () {
        return _.where(this.itemsFiltered, { collection: 'NightMare' })
      },
    },
  }
</script>


<template>
  <ItemPage :items="items" :narrowCols="[1,2,8]">

    <template #title>
      <PageChooser />
      <time>{{ date }}</time>
    </template>

    <template #col1>
      <ItemList title="⭐️ WR ⭐️" color="#ffca59" :items="itemsWR" />
      <ItemList title="🥚 ER 🥚" color="#44cd1f" :items="itemsER" />
    </template>

    <template #col2>
      <ItemList title="✨ IR ✨" color="#edd50f" :items="itemsIR" />
    </template>

    <template #col3>
      <ItemList title="👑 FR 👑" color="#ff5d91" :items="itemsFR" />
      <ItemList title="PR ★★★" color="#ffa1bc" :items="itemsPR" />
    </template>

    <template #col4>
      <ItemList title="SR ★★" color="#00c7da" :items="itemsSR" />
      <ItemList title="モーリー限定 SR ★★" color="#55b272" :items="itemsMolly" />
    </template>

    <template #col5>
      <ItemList title="R ★" color="#feab0d" :items="itemsR" />
    </template>

    <template #col6>
      <ItemList title="N" color="#f6c3b2" :items="itemsN" />
      <ItemList title="パシャッとアイテム" color="#c598ff" :items="itemsPasha" />
      <ItemList title="プレゼントボックス" color="#c598ff" :items="itemsPBox" />
    </template>

    <template #col7>
      <ItemList title="サンリオキャラクターズ|チャンネル" color="#a1c0fa" :items="itemsSanrio" />
      <ItemList title="ラブパトリーナ|チャンネル" color="#a1c0fa" :items="itemsLovePato" />
      <ItemList title="いたずらナイトメア|チャンネル" color="#a1c0fa" :items="itemsNightMare" />
    </template>

    <template #col8>
      <ItemList title="ハッピーレア大量発生|チャンネル" color="#ff5d91" :items="itemsHR" />
    </template>

    <template #col9>
      <ItemList title="ニコチケ PR ★★★" color="#ffa1bc" :items="itemsNicoPR" />
      <ItemList title="ニコチケ SR ★★" color="#00c7da" :items="itemsNicoSR" />
    </template>

    <template #col10>
      <ItemList title="ニコチケ R ★" color="#feab0d" :items="itemsNicoR | first(7 * 4)" />
    </template>

    <template #col11>
      <ItemList title="ニコチケ R ★" color="#feab0d" :items="itemsNicoR | rest(7 * 4)" :isOrphan="true" />
      <Status :date="date" :items="items" :showKira="true" :showNico="true" />
    </template>

  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  // PC View: ステータスの表示位置を調整
  .Page ::v-deep .Status {
    // PC View のとき position: absolute になっている (see: ItemPage.vue)
    bottom: 0;
    left: 0;
  }

  // PC View: ステータス表示を置く空間を確保
  // @include iroha-vw-range($from: strip-unit($device-width--pc), $also-apply: print) {
  //   .Page ::v-deep .Page__body {
  //     padding-bottom: $size-unit * 20;
  //   }
  // }
</style>
